import React from 'react';
import { useTabsContext } from './TabsContext';

interface TabsContentProps {
  value: string;
  children: React.ReactNode;
}

export const TabsContent: React.FC<TabsContentProps> = ({ value, children }) => {
  const { activeTab } = useTabsContext();
  
  if (activeTab !== value) return null;
  
  return <div className="py-4">{children}</div>;
};